export enum ArchiveFileSyncRuleType {
  FORM = 'FORM',
  MATERIAL = 'MATERIAL',
}
